import { ReactNode } from "react";
import { Tag, Tooltip } from "antd"

export const TagsCell = (tags: {_id: string; name: ReactNode}[]) => {
  const firstTags = tags?.slice(0, 2)
  const restTags = tags?.slice(2)
  return (
    <>
      {firstTags?.map((tag) => (
        <Tag key={tag._id}>{tag.name}</Tag>
      ))}
      {restTags.length > 0 && (
        <Tooltip
          key='rest'
          title={restTags.map((tag) => (
            <Tag key={tag._id} className='my-1'>
              {tag.name}
            </Tag>
          ))}
        >
          <Tag>+{restTags.length}...</Tag>
        </Tooltip>
      )}
    </>
  )
}
